import { Link } from "react-router-dom";

const Allpools = ({
  menuAllPools,
  isLoading,
  filteredAllPools,
  toggleMenuItem,
  toggleFilter,
  visibleFilter,
  handleFlyToCity,
}) => {
  const renderPlaceholder = () => (
    <div className="staking-list placeholder-glow">
      {[...Array(3)].map((_, index) => (
        <div
          key={index}
          className="placeholder col-12"
          style={{ marginTop: "14px" }}
        ></div>
      ))}
    </div>
  );

  const renderPoolStatus = () => {
    if (!filteredAllPools) return null;
    return Object.keys(filteredAllPools).map(
      (status, index) =>
        status !== "Ended" && (
          <div key={index} className="d-flex flex-column">
            <div
              className={
                !visibleFilter[status] ? "title-list" : "title-list-hide"
              }
              onClick={() => toggleFilter(`${status}`)}
            >
              {status === "Coming Soon" ? `${status}` : `${status} Status`}
            </div>
            {!visibleFilter[status] &&
              filteredAllPools[status].map((pool) => (
                <Link key={pool.poolId} onClick={() => handleFlyToCity(pool)}>
                  {pool.name}{" "}
                </Link>
              ))}
          </div>
        )
    );
  };

  return (
    <>
      <div
        className={menuAllPools ? "title-list" : "title-list-hide"}
        onClick={() => toggleMenuItem("allpool")}
      >
        Active Pools
      </div>

      {isLoading
        ? renderPlaceholder()
        : menuAllPools && (
            <div className="staking-list"> {renderPoolStatus()} </div>
          )}
    </>
  );
};

export default Allpools;
